Vue.component("shop-popup", {
	props: {
		shop: Object,
	},

	template: `
	<div class="search-shop search-dialog">
		<div class="search-dialog-backdrop" @click="$emit('close')"></div>
		<div class="search-dialog-inner">
			<div class="search-dialog-header">
				<h2 class="hd">銭湯詳細</h2>
				<button type="button" class="btn btn-s pull-left" @click="$emit('close')">閉じる</button>
			</div>
			<div class="search-dialog-content">
				<div class="pane visible search-shop-detail search-shop-detail-content" :class="{closed: shop.is_perm_closed || shop.is_closed}">
					<div class="hd">
						<p>{{ shop.kana }}</p>
						<h3>
							{{ shop.name }}
							<span class="fi fi-disabled" v-if="shop.is_perm_closed">閉店</span>
							<span class="fi fi-disabled" v-else-if="shop.is_closed">休業中</span>
						</h3>
					</div>
					<div class="addr-tel">
						<ul class="feature-list">
							<li>{{ shop.city }}{{ shop.address }} {{ shop.address2 }}</li>
							<template v-if="!shop.is_closed && !shop.is_perm_closed">
								<li v-if="shop.tel"><span class="fi">Tel</span> {{ shop.tel }}</li>
								<li v-if="shop.website"><span class="fi">Web</span> <a :href="shop.website" target="_blank">{{ shop.website }}</a></li>
							</template>
						</ul>
					</div>
					<div class="info">
						<ul class="feature-list" v-if="!shop.is_closed && !shop.is_perm_closed">
							<li><span class="fi" aria-label="営業時間">営</span> {{ shop.open_time }}</li>
							<li><span class="fi" aria-label="休業日">休</span> {{ shop.closed }}</li>
							<li v-if="shop.num_parking > 0">
								<span class="fi" aria-label="駐車場">駐</span> {{ shop.num_parking }}&nbsp;台
								{{ shop.parking_desc }}
							</li>
							<li v-else><span class="fi" aria-label="駐車場">駐</span> なし</li>
						</ul>
					</div>
					<div class="img">
						<div class="img-inner">
							<div class="slide-list" v-if="hasMultipleImages" :data-images="imageJSON">
								<div class="slide">
									<img alt="" :src="'/uploads/raw/' + shop.image">
								</div>
							</div>
							<div class="slide" v-else>
								<img alt="" :src="'/uploads/raw/' + shop.image">
							</div>
						</div>
					</div>
					<div class="desc" v-if="shop.description">
						<p>{{ shop.description }}</p>
					</div>
					<div class="desc" v-if="shop.access">
						<h4 class="desc-hd">アクセス</h4>
						<p>{{ shop.access }}</p>
					</div>
					<div class="desc" v-if="shop.spot">
						<h4 class="desc-hd">周辺スポット</h4>
						<p>{{ shop.spot }}</p>
					</div>
					<div class="features">
						<ul class="feature-list feature-list-fixed">
							<template v-for="facility in store.facilities">
								<li v-if="shop[facility.name]">
									<span class="fl"><span>{{ facility.label }}</span></span>
								</li>
							</template>
							<template v-for="feature in store.bathFeatures">
								<li v-if="shop[feature.name]">
									<span class="fl fl-yu"><span>{{ feature.label }}</span></span>
								</li>
							</template>
						</ul>
					</div>
					<div class="map">
						<shop-map-view :shop="shop"></shop-map-view>
					</div>
				</div>
			</div>
		</div>
	</div>
	`,

	data() {
		return {
			store,
		};
	},

	computed: {
		hasMultipleImages() {
			const {shop} = this;
			for (let i = 1, count = 0; i <= 3; i++) {
				const key = (i === 1) ? "image" : "image" + i;
				if (shop[key]) {
					count++;
					if (count >= 2) {
						return true;
					}
				}
			}
			return false;
		},

		imageJSON() {
			const {shop} = this;

			const images = [];
			for (let i = 1; i <= 3; i++) {
				const key = (i === 1) ? "image" : "image" + i;
				if (shop[key]) {
					images.push({title: "", src: "/uploads/raw/" + shop[key]});
				}
			}
			return JSON.stringify(images);
		},
	},
});
